import ServerApi from './$server.api'

export default {
    getShipment,
    getShipments,
    getShipmentsZone,
}

async function getShipment(shipmentId) {
    return await ServerApi.request('get', `/shipments/${shipmentId}`)
}

async function getShipments(query = {}) {
    return await ServerApi.request('get', '/shipments', {query})
}

async function getShipmentsZone(zoneId, query = {}) {
    return await ServerApi.request('get', `/shipments/zone/${zoneId}`, {query})
}